import React from "react"
import { CarouselComponent } from "../CarouselComponent"

export const YouTubeTvWelcomeComponent = () => {
  return (
    <CarouselComponent images={["/images/YouTubeTV/landing.png"]}>
        <div className="row">
          <div className="col mx-auto">
            <h1 className="text-center">Ready to redeem your YouTube subscription offers?</h1>
          </div>
        </div>
    </CarouselComponent>
  )
}
